export const routes = {
  sso: "/",
  user: "/user/:userId",
  home: "/home",

  pageNotFound: "/*",
} as const
